import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);



// Initialize Firebase

export default new Vuex.Store({
  name: 'store',
  state: {
    _fb: null,
    user: JSON.parse(window.localStorage.getItem("deviceUser"))
     ? JSON.parse(window.localStorage.getItem("deviceUser"))
     : {
      data: null,
      uid: "",
      email: "",
      emailVerified: false,
      signedIn: false,
      signedUp: false,
      userStatus: ""
    },
    _error: null,
    //defaultCounty: JSON.parse(window.localStorage.getItem("county"))
    //  ? JSON.parse(window.localStorage.getItem("county"))
    //  : { county: "Wasatch", ID: 'was' },
    defaultCounty: { county: "Wasatch", ID: 'was' },
    _frontEndServerURL: "https://upp.wasatch.utah.gov/",
    _backEndServerURL: "dbb/"
  },

  getters: {
    userSignedIn: function (state) {
      return state.user.emailVerified;
    },
    user: function (state) {
      return state.user;
    },
    userStatus: function (state) {
      return state.user.userStatus;
    },
    fb: function (state) {
      return state._fb;
    },          
    frontEndServerURL: function(state) {
      return state._frontEndServerURL;
    },
    backEndServerURL: function(state) {
      return state._backEndServerURL;
    },
    county: function(state) {
      return state.defaultCounty;
    },
    error: function(state) {
      return state._error;
    }
  },

  mutations: {
    setFrontEndServerURL(state, url) {
      state._frontEndServerURL = url;
    },
    setBackEndServerURL(state, url) {
      state._backEndServerURL = url;
    },
    setDefaultCounty(state, c) {
      window.localStorage.setItem("county", JSON.stringify(c));
      state.defaultCounty = c;
    },
    setFirebase(state, payload) {
      if (payload != null) {
        state._fb = payload;
      } else {
        state._fb = null;
      }
    },
    setUserSignedIn(state) {
      state.user.signedIn = state.user.emailVerified;
    },
    setUser(state, payload) {
      if (payload != null) {
        window.localStorage.setItem("deviceUser", JSON.stringify(payload));
        state.user.data = payload;
        state.user.uid = payload.uid;
        state.user.email = payload.email;
        state.user.emailVerified = payload.emailVerified;
        state.user.signedIn = true;
        state.user.signedUp = true;
        state.user.userStatus = "success";
      } else {
        window.localStorage.removeItem("deviceUser");
        state.user.data = null;
        state.user.uid = "";
        state.user.email = "";
        state.user.emailVerified = false;
        state.user.signedIn = false;
        state.user.signedUp = false;
        state.user.userStatus = "failure";
      }
    },
    setStatus(state, payload) {
      if (payload != null) {
        state.user.userStatus = payload;
      } else {
        state.user.userStatus = payload;
      }
    },

    removeUser(state ) {
      window.localStorage.deleteItem("deviceUser");
      state.user.data = null;
      state.user.userStatus = "failure";
      state.user.email = "";
      state.user.emailVerified = false; 
      state.user.uid = "";
      state.user.signedIn = false;
      state.user.signedUp = false;
    },

    setError(state, payload) {
      state._error = payload;
    },
  },

  actions: {
    commitCounty({ commit }, payload) {
      if (payload) {
        commit("setDefaultCounty", payload);
      } else {
        commit("setDefaultCounty", null);
      }
    },
    commitFirebase({ commit }, payload) {
      if (payload) {
        commit("setFirebase", payload);
      } else {
        commit("setFirebase", null);
      }
    },
    
    commitFrontEndServerURL({ commit }, payload) {
      if (payload) {
        commit("setFrontEndServerURL", payload);
      } else {
        commit("setFrontEndServerURL", null);
      }
    },
    commitBackEndServerURL({ commit }, payload) {
      if (payload) {
        commit("setBackEndServerURL", payload);
      } else {
        commit("setBackEndServerURL", null);
      }
    },

    commitUser({ commit }, payload) {
      if (payload) {
        commit("setUser", payload);
      } else {
        commit("setUser", null);
      }
    },

    signOutAction({ commit }) {
          commit("setUser", null);
    },

    signInAction({ commit }) {
      commit("setUser", null);
    },
  },
  modules: {},

});
